import React from "react";

export default function ListMenu({ userType }) {
  return (
    <div className="menuContainer primary white">
      {userType === 1 && <div className="menuUsername">SUPER</div>}
      {(userType === 1 || userType === 2) && (
        <div className="menuUsername">MASTER</div>
      )}
      <div className="menuUsername small">Username</div>
      <div className="menuUsername small">Booked</div>
      <div className="menuUsername small">Net-Booked</div>
      <div className="menuUsername small">Commission</div>
      <div className="menuUsername small">Net-Commission</div>
      <div className="menuName small">Trade</div>
      <div className="menuName small">Close Only</div>
      <div className="menuName small">Status</div>
      <div className="menuName small">Ip Address</div>
      <div className="menuName small">Created Date</div>
      <div className="menuName small">Last Login</div>
      <div className="menuName small"></div>
    </div>
  );
}
